import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
// Layouts
import { MarketingLayout } from './layouts/MarketingLayout';
import { AppLayout } from './layouts/AppLayout';
import { SetupLayout } from './layouts/SetupLayout';
// Marketing Pages
import { LandingPage } from './pages/LandingPage';
import { PricingPage } from './pages/PricingPage';
// Setup Flow Pages
import { SetupWizardPage } from './pages/SetupWizardPage';
import { RecommendationPage } from './pages/RecommendationPage';
import { ProvisioningPaymentPage } from './pages/ProvisioningPaymentPage';
import { ProvisioningProgressPage } from './pages/ProvisioningProgressPage';
import { ImplementationPackPage } from './pages/ImplementationPackPage';
// App Dashboard Pages
import { DashboardPage } from './pages/DashboardPage';
import { MonitoringPage } from './pages/MonitoringPage';
import { BillingSettingsPage } from './pages/BillingSettingsPage';
import { BlueprintPage } from './pages/BlueprintPage';
import { ProviderSelectionPage } from './pages/ProviderSelectionPage';
export function App() {
  return <HashRouter data-id="element-0">
      <Routes data-id="element-1">
        {/* Marketing Routes */}
        <Route element={<MarketingLayout data-id="element-3" />} data-id="element-2">
          <Route path="/" element={<LandingPage data-id="element-5" />} data-id="element-4" />
          <Route path="/pricing" element={<PricingPage data-id="element-7" />} data-id="element-6" />
        </Route>

        {/* Setup Flow Routes (Minimal Layout) */}
        <Route element={<SetupLayout data-id="element-9" />} data-id="element-8">
          <Route path="/setup" element={<SetupWizardPage data-id="element-11" />} data-id="element-10" />
          <Route path="/setup/recommendation" element={<RecommendationPage data-id="element-13" />} data-id="element-12" />
          <Route path="/setup/provision" element={<ProvisioningPaymentPage data-id="element-15" />} data-id="element-14" />
          <Route path="/setup/progress" element={<ProvisioningProgressPage data-id="element-17" />} data-id="element-16" />
        </Route>

        {/* App Dashboard Routes (Sidebar Layout) */}
        <Route element={<AppLayout data-id="element-19" />} data-id="element-18">
          <Route path="/setup/complete" element={<ImplementationPackPage data-id="element-21" />} data-id="element-20" />
          <Route path="/dashboard" element={<DashboardPage data-id="element-23" />} data-id="element-22" />
          <Route path="/blueprint" element={<BlueprintPage data-id="element-25" />} data-id="element-24" />
          <Route path="/providers" element={<ProviderSelectionPage data-id="element-27" />} data-id="element-26" />
          <Route path="/monitoring" element={<MonitoringPage data-id="element-29" />} data-id="element-28" />
          <Route path="/settings" element={<BillingSettingsPage data-id="element-31" />} data-id="element-30" />
        </Route>
      </Routes>
    </HashRouter>;
}